import * as types from './types'

export default {
  [types.SET_STANDARD_OPENING_HOURS](state, value) {
    if (value !== undefined && value !== null) {
      state.standardOpeningHours = value
    }
  },
  [types.SET_HOLIDAY_OPENING_HOURS](state, value) {
    if (value !== undefined && value !== null) {
      state.holidayOpeningHours = value
    }
  },
  [types.SET_TENANT_DETAILS](state, value) {
    if (value !== undefined && value !== null) {
      state.tenantDetails = value
    }
  },
  [types.SET_SELECTED_TENANT](state, tenant) {
    state.selectedTenant = tenant
  },
  [types.UPDATE_TENANT_SUPPORT_EMAIL](state, { tenantID, email }) {
    const tenants = JSON.parse(state.tenantDetails)
    const tenant = tenants.find(t => t.ID === tenantID)
    if (tenant) {
      tenant.SupportEmail = email
    }
  },
  [types.SET_SORT_DIR](state, text) {
    if (text !== undefined && text !== null) {
      state.sortDir = text
    }
  },
  [types.SET_ORDER_BY](state, text) {
    if (text !== undefined && text !== null) {
      state.orderBy = text
    }
  },
  [types.SET_OUT_OF_HOURS_AUDIT_LOG](state, data) {
    state.totalLogEntries = 0
    state.outOfHoursAuditLog = []
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.totalLogEntries = data[0].TotalItems
        state.outOfHoursAuditLog = data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/openinghours/mutations.js